/* unplugin-vue-components disabled */import script from "./ipWhiteList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ipWhiteList.vue?vue&type=script&setup=true&lang=ts"

import "./ipWhiteList.vue?vue&type=style&index=0&id=31c9e56c&lang=less&scoped=true"

import exportComponent from "/Users/zpw/Documents/hero/ultrasdk.hub.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.0.0_vue@2.6.10_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31c9e56c"]])

export default __exports__